import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
//import AboutUsImgGallery from "./AboutUsImgGallery";

class Watering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wateringpage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "watering",
    }).then((entries) => {
      this.setState({ wateringpage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(wateringDescription) {
    return {
      __html: marked(wateringDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <div className="container-fluid">
        {this.state.wateringpage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.wateringpage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1>{item.fields.wateringTitle}</h1>
                    <h2 className="lead">{item.fields.wateringShortText}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.wateringImg.fields.file.url}
                          alt="sam bridge watering"
                        />
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.wateringDescription
                        )}></div>
                      </div>
                    </div>
                    {/* <div>
                    <p>{item.fields.wateringDescriptionPhotos}</p>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* <div>
            <AboutUsImgGallery/>
        </div> */}
      </div>
    );
  }
}

export default Watering;
